import React from "react";
import "./About.css";
import aboutpaint from "../assets/aboutpaint.png";

export default function About() {
  return (
    <section className="about-section">
      <div className="about-wrapper">
        {/* White Rounded Container with Custom Border */}
        <div className="about-box">
          {/* Overlay Paint Design */}
          <div className="overlay-paint">
            <img src={aboutpaint} alt="Paint Overlay" className="overlay-img" />
            <div className="overlay-text">
              <h4>ASH GREY</h4>
              <p>COLOUR CODE: 003</p>
              <a href="/" className="overlay-link">
                View All Products
              </a>
            </div>
          </div>

          {/* About Content */}
          <div className="about-content">
            <h3>About Us</h3>
            <h4>Pakistan’s Top Choice in Locally Manufactured Paints</h4>
            <p>
              Since 1984, Glamur Paints has been synonymous with exceptional
              wall paint solutions across Pakistan. What started as a family
              vision in Sindh Province has grown into one of Pakistan's leading
              paint manufacturers, trusted by homeowners, contractors, and
              architects nationwide.
            </p>
            <p>
              Unlike other paint brands in Pakistan, Glamur Paints offers
              uncompromising quality at competitive prices. We understand that
              in Pakistan's paint market, many local painters recommend products
              based on their commission rather than quality. That's why we've
              built direct relationships with customers, ensuring you get honest
              recommendations and superior paint products that deliver lasting
              results.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
